import { api } from '../axiosInstance';
import { ApiResponseType } from '../type/commonTypes';

type PLATFORM_TYPE = 'web';

interface postFcmDeviceTokenProps {
  token: string;
  platform: PLATFORM_TYPE;
}

export const postFcmDeviceToken = async (data: postFcmDeviceTokenProps) => {
  const res = await api.post<ApiResponseType<void>>(
    '/api/notifications/device-tokens',
    data
  );
  return res.data;
};
